import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as toastActions from '../../actions/toast';
import closeIcon from '../../assets/images/times-solid-white.svg';

const ErrorMessage = ({ entity }) => {
  return (
    <div>
      <h4 style={{ color: 'white', marginTop: 0 }}>
        <strong>ERROR</strong>
      </h4>
      <span>Error occured !!! {entity}</span>
    </div>
  );
};

const SuccessMessage = ({ message }) => {
  return <span>SUCCESS!!! {message}</span>;
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  width: 380,
  position: 'fixed',
  right: 40,
  top: -100,
  opacity: 0,
  minHeight: 60,
  transition: 'top 0.25s ease-in, opacity 0.25s ease-in',
  zIndex: 10000,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
};

const containerTransitionStyle = {
  ...containerStyle,
  top: 40,
  opacity: 1,
  transition: 'top 0.25s ease-out, opacity 0.25s ease-in',
};

const textContainerStyle = {
  display: 'flex',
  padding: '13px 13px 13px 19px',
  width: '100%',
  backgroundColor: 'white',
  borderRadius: '2px',
  justifyContent: 'space-between',
};

const Toast = () => {
  const dispatch = useDispatch();
  const currentToast = useSelector((state) => state.getIn(['app', 'toast', 0]));
  const [transition, setTransition] = useState(false);

  useEffect(() => {
    if (!currentToast) {
      return undefined;
    }
    const t1 = setTimeout(() => setTransition(true), 0);
    const t2 = setTimeout(() => setTransition(false), 4000);
    const t3 = setTimeout(() => dispatch(toastActions.pop()), 4250);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [currentToast, dispatch]);

  const popToast = () => dispatch(toastActions.pop());

  if (!currentToast) {
    return <div />;
  }

  const type = currentToast.get('type');
  const message = currentToast.get('message');
  const error = currentToast.get('error');
  const entity = currentToast.get('entity');

  return (
    <div
      className='toast-container'
      key='toastContainer'
      role='alert'
      style={transition ? containerTransitionStyle : containerStyle}
    >
      <div
        style={{
          ...textContainerStyle,
          ...(type === 'error'
            ? { backgroundColor: '#c0392b', color: 'white' }
            : {}),
          ...(type === 'success'
            ? { backgroundColor: '#0574a6', color: 'white' }
            : {}),
        }}
      >
        <div>
          {type === 'error' && <ErrorMessage entity={entity} error={error} />}
          {type === 'success' && <SuccessMessage message={message} />}
        </div>
        <button
          aria-label='Dismiss notification'
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            padding: 0,
          }}
          type='button'
          onClick={popToast}
        >
          <img alt='' className='inline-icon' src={closeIcon} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
export { ErrorMessage, SuccessMessage };
